import React, { useContext, useState } from 'react';
import { actionContext } from "../../app/page";
import { CasinoImageInterface, exportNewCasinoJson, otherCasino } from "../../data/gameData_casino";
import { SlotImageInterface, exportNewSlotJson } from "../../data/gameData_slot";
import { loadingContext } from "../provider/game_loading_provider";
import { ErrorVendorCheck } from "../../util/ErrorVendorCheck";
import { UserContext } from "../../app/_root";
import AudioPlayer from "../layout/audio_player";
import { lobbyModalContext } from "../provider/lobby_modal_provider";
import MediaPlayer from "../layout/media_player";

import swal from "sweetalert"
import TitleHeader from '../layout/title_header';
import GameTitleHeader from '../layout/gameTitleHeader';

export function NewGameList() {
    const { User } = useContext(UserContext)
    const { SetLoginPop } = useContext(actionContext)
    // sessionStorage.setItem('test', '1')
    return (
        <div>
            {/* <TitleHeader type="casino">
                <p>라이브 카지노</p>
                <span>Live Casino</span>
            </TitleHeader> */}
            <GameTitleHeader type="casino" />
            <main className={"new-company-list casino"}>
                {
                    exportNewCasinoJson.map((comp, index) => {
                        return (
                            <CompanyItems key={index}
                                isLogin={User?.is_authenticated ? true : false}
                                SetLoginPop={SetLoginPop}
                                company={comp} />
                        )
                    })
                }
            </main>
        </div>
    );
}

function CompanyItems({ company, isLogin, SetLoginPop }: { company: CasinoImageInterface, isLogin: boolean, SetLoginPop: Function }) {
    const { SetLoadingPop } = useContext(loadingContext)
    const [audioPlay, setAudioPlay] = useState<boolean>(false)
    const { SetLobbyShow, SetVendor, SetType } = useContext(lobbyModalContext)

    return (
        <div
            onClick={e => {
                if (isLogin) {
                    if (otherCasino.includes(company.vendor)) {
                        SetVendor(company.vendor)
                        SetType('casino')
                        SetLobbyShow()
                    } else {
                        // SetLoadingPop(true)
                        // ErrorVendorCheck(company.vendor, company.id, 'casino')
                        //     .finally(()=> SetLoadingPop(false))
                        window.open(`/gameLobby/${company.vendor}/?type=casino&uid=${company.id}&vendor=${company.vendor}`,
                            `${company.vendor}_${company.id}`, `width=1200 height=640`)
                    }
                    // window.open(`/api/game/lobbies/${company.vendor}/${company.id}`, `lobby`,`popup,width=1200, height=600`)
                } else {
                    SetLoginPop()
                }
            }}>
            <div className={'hover-cover'}
                onMouseOver={e => setAudioPlay(true)}
                onMouseOut={e => setAudioPlay(false)}
            ></div>
            <div className='border-frame'></div>
            <div className='patterns'>
                <div className='girl'>
                    <img src={company.img} alt="" />
                </div>
                <div className='company-logo'>
                    <img src={company.logo} alt="" />
                </div>
                <div className='game-start'>
                    <button>게임시작</button>
                </div>
            </div>
            <AudioPlayer type={"company"} play={audioPlay} />
        </div>
    )
}

// **************************************************************************************
// **************************************************************************************
// **************************************************************************************

export function NewSlotList() {
    const { User } = useContext(UserContext)
    const { SetLoginPop } = useContext(actionContext)
    return (
        <div>
            {/* <TitleHeader type="slot">
                <p>슬롯머신</p>
                <span>slot machine</span>
            </TitleHeader> */}
            <GameTitleHeader type="slot" />
            <main className={"new-company-list slot"}>
                {
                    exportNewSlotJson.map((comp, index) => {
                        return (
                            <SlotItems key={index}
                                isLogin={User?.is_authenticated ? true : false}
                                SetLoginPop={SetLoginPop}
                                company={comp} />
                        )
                    })
                }
            </main>
        </div>
    );
}

function SlotItems({ company, isLogin, SetLoginPop }: { company: SlotImageInterface, isLogin: boolean, SetLoginPop: Function }) {
    const { SetLobbyShow, SetVendor, SetType } = useContext(lobbyModalContext)
    const [audioPlay, setAudioPlay] = useState<boolean>(false)
    return (
        <div
            onClick={e => {
                if (isLogin) {
                    // SetLoadingPop(true)
                    if (['popok',].includes(company.vendor)) {
                        swal({
                            text: '점검중 입니다.',
                            icon: 'warning'
                        })
                    } else if (company.vendor == 'Booongo') {
                        window.open(`/gameLobby/Booongo/?uid=bng_mini_lobby&vendor=Booongo`,
                            // window.open(`https://slot-cu88.com/gameLobby/Booongo/?uid=bng_mini_lobby&vendor=Booongo`,
                            `${company.vendor}_${company.id}`, `width=1200 height=640`)
                    }
                    else if (company.vendor == 'MicroGaming Plus Slo') {
                        window.open(`/gameLobby/MicroGaming Plus Slo/?vendor=MicroGaming%20Plus%20Slo&uid=falconlobby`,
                            `${company.vendor}_${company.id}`, `width=1200 height=640`)
                    } else {
                        SetVendor(company.vendor)
                        SetType('slot')
                        SetLobbyShow()
                    }
                    // ErrorVendorCheck(company.vendor, company.id, 'slot')
                    //     .finally(()=> SetLoadingPop(false))
                } else {
                    SetLoginPop()
                }
            }}
        >
            <div className={'hover-cover'}
                onMouseOver={e => setAudioPlay(true)}
                onMouseOut={e => setAudioPlay(false)}
            ></div>
            <div className='chip'>
                <div className='inner'>
                    <img src={company.img} className={"original"} />
                    <div className={'focus-btn-slot'}>
                        <button>게임입장</button>
                    </div>
                </div>
            </div>
            <div className='game-logo'>
                <img src={company.logo} alt="" title={company.name} />
                <p>{company.name}</p>
            </div>
            <AudioPlayer type={"company"} play={audioPlay} />
        </div>
    )
}
